import { render } from "./TicketActivityLogs.vue?vue&type=template&id=48bbfb66"
import script from "./TicketActivityLogs.vue?vue&type=script&lang=js"
export * from "./TicketActivityLogs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__